import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {ChartsSearchInterface} from '../../../../models/charts-search.interface';
import {Master} from '../../../../../admin/models/master.interface';
import {MatSelectChange} from '@angular/material/select';
import {REGIONS} from '../../../../../constants/constants';
import {setFormValuesFromQueryParams} from '../../../../utils/filters-utils';
import {ActivatedRoute} from '@angular/router';
import {MatOption} from '@angular/material/core';

@Component({
  selector: 'app-trend-by-country-filters',
  templateUrl: './trend-by-country-filters.component.html',
  styleUrls: ['./trend-by-country-filters.component.scss']
})
export class TrendByCountryFiltersComponent implements OnInit, OnChanges {

  regions = REGIONS;

  @ViewChild('allSelected') private allSelected!: MatOption;

  @Input()
  years!: number[];
  @Input()
  categories!: Master[];
  @Input()
  countryCategory!: string;

  searchForm = this.formBuilder.group({
    startYear: [''],
    categoryType: ['NEW'],
    categories: [''],
    detailLevel: [],
    b2bB2c: [],
    member: [],
    region: [''],
    order: [],
    displayUnits: ['ABSOLUTE'],
  });

  get startYearControl(): FormControl {
    return this.searchForm.get('startYear') as FormControl;
  }

  get categoryTypeControl(): FormControl {
    return this.searchForm.get('categoryType') as FormControl;
  }

  get categoriesControl(): FormControl {
    return this.searchForm.get('categories') as FormControl;
  }

  get detailLevelControl(): FormControl {
    return this.searchForm.get('detailLevel') as FormControl;
  }

  get b2bB2cControl(): FormControl {
    return this.searchForm.get('b2bB2c') as FormControl;
  }

  get memberControl(): FormControl {
    return this.searchForm.get('member') as FormControl;
  }

  get regionControl(): FormControl {
    return this.searchForm.get('region') as FormControl;
  }

  get orderControl(): FormControl {
    return this.searchForm.get('order') as FormControl;
  }


  @Output()
  search: EventEmitter<ChartsSearchInterface> = new EventEmitter<ChartsSearchInterface>();
  @Output()
  loadCategories: EventEmitter<string> = new EventEmitter<string>();


  constructor(private formBuilder: FormBuilder,
              private activatedRouter: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.startYearControl.setValue(this.years[2]);
    setFormValuesFromQueryParams(this.searchForm, this.activatedRouter);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.categories?.length) {
      if (changes.categories || !this.categoriesControl.value || this.categoriesControl.value.length === this.categories.length) {
        if (this.allSelected) {
          this.allSelected.select();
        }
        this.categoriesControl
          .patchValue([...this.categories.map(item => item.id.toString()), 0]);
      }
    }
  }

  handleSubmit(): void {
    const search: ChartsSearchInterface = {
      startYear: this.startYearControl.value,
      categoryType: this.categoryTypeControl.value,
      categories: this.categoriesControl.value,
      detailLevel: this.detailLevelControl.value,
      b2bB2c: this.b2bB2cControl.value,
      member: this.memberControl.value,
      region: this.regionControl.value,
      order: this.orderControl.value,
      displayUnits: this.searchForm.controls.displayUnits.value,
    };
    this.search.emit(search);
    if (this.categoriesControl.value.length === this.categories.length) {
      this.allSelected.select();
    }
  }

  clean(): void {
    this.startYearControl.setValue(this.years[this.years.length - 1]);
    this.categoryTypeControl.setValue('NEW');
    this.categoriesControl.setValue('');
    this.detailLevelControl.setValue(null);
    this.b2bB2cControl.setValue(null);
    this.memberControl.reset();
    this.regionControl.reset();
    this.orderControl.setValue(null);
    this.searchForm.controls.displayUnits.setValue('ABSOLUTE');
    this.search.emit({startYear: this.years[2], categoryType: 'NEW', displayUnits: 'ABSOLUTE'});
  }

  getCategories(event: MatSelectChange): void {
    if (event?.value) {
      this.loadCategories.emit(event.value);
    }
  }

  togglePerOne(): void {
    if (this.allSelected.selected) {
      this.allSelected.deselect();
      return;
    }
    if (this.categoriesControl.value.length === this.categories.length) {
      this.allSelected.select();
    }
  }

  toggleAllSelection(): void {
    if (this.allSelected.selected) {
      this.categoriesControl
        .patchValue([...this.categories.map(item => item.id.toString()), 0]);
    } else {
      this.categoriesControl.patchValue([]);
    }
  }

}
